export default __webpack_public_path__ + "static/media/eye-crossed.7752cdd5.svg";